const menu={key:"aiDevelopmentProjects",route:"/ai-development/projects",label:"aiDevelopment.projects",permission:"ai.development.admin",icon:"faFolderTree",group:"aiDevelopment",groupLabel:"aiDevelopment.title",order:20};
export default menu;
